__turbopack_context__.v({
  "askNote": "AskDetail-module__X3v--q__askNote",
  "categoryLabel": "AskDetail-module__X3v--q__categoryLabel",
  "categoryPill": "AskDetail-module__X3v--q__categoryPill",
  "categorySwatch": "AskDetail-module__X3v--q__categorySwatch",
  "container": "AskDetail-module__X3v--q__container",
  "deck": "AskDetail-module__X3v--q__deck",
  "eyebrow": "AskDetail-module__X3v--q__eyebrow",
  "eyebrowGroup": "AskDetail-module__X3v--q__eyebrowGroup",
  "eyebrowRow": "AskDetail-module__X3v--q__eyebrowRow",
  "goDeeperContainer": "AskDetail-module__X3v--q__goDeeperContainer",
  "goDeeperHeading": "AskDetail-module__X3v--q__goDeeperHeading",
  "heading": "AskDetail-module__X3v--q__heading",
  "headingBlock": "AskDetail-module__X3v--q__headingBlock",
  "noteBody": "AskDetail-module__X3v--q__noteBody",
  "noteContainer": "AskDetail-module__X3v--q__noteContainer",
  "prose": "AskDetail-module__X3v--q__prose",
  "proseBody": "AskDetail-module__X3v--q__proseBody",
  "refContainer": "AskDetail-module__X3v--q__refContainer",
  "relArrow": "AskDetail-module__X3v--q__relArrow",
  "relBody": "AskDetail-module__X3v--q__relBody",
  "relCard": "AskDetail-module__X3v--q__relCard",
  "relCat": "AskDetail-module__X3v--q__relCat",
  "relImg": "AskDetail-module__X3v--q__relImg",
  "relImgEl": "AskDetail-module__X3v--q__relImgEl",
  "relList": "AskDetail-module__X3v--q__relList",
  "relTitle": "AskDetail-module__X3v--q__relTitle",
  "section": "AskDetail-module__X3v--q__section",
  "separator": "AskDetail-module__X3v--q__separator",
  "stand": "AskDetail-module__X3v--q__stand",
});
